import BC from "../init";

console.log('expand');
export default BC.Methods.propertiesExpander = ($this) => {

    const content  = $this.querySelector('.user-content');
    let htmlContent = content.innerHTML;
    let parentElement = content.parentElement;
    let closestMoreContent = $this.querySelector('.properties-partial-content-more-text');
    closestMoreContent.innerHTML = htmlContent;

    if (htmlContent.length > 500) {
        const shortenedContent = htmlContent.substring(0, 500) + '...';
        content.innerHTML = shortenedContent;
    }

    let showMoreButton = $this.querySelector('.toggle-intro-content');
    showMoreButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        content.classList.add('hide');
        showMoreButton.classList.add('hide');
        closestMoreContent.classList.remove('hidden');
    });
};